import $ from 'jquery';

$(document).on('click', '#gift-code-toggle', function(e){
  e.preventDefault();
  const form = $('#gift-code-form').toggleClass('d-none');
  $('#checkout-btn').toggleClass('d-none');
  $('#coupon-code-form').addClass('d-none');
  if (form.hasClass('d-none')) {
    $(this).text('Tengo un c\u00f3digo de regalo');
  } else {
    $(this).text('Cancelar');
  }
});
